import { TableColumnDef } from '@common/datatable';

export function getUniqueId({ colId, field }: Pick<TableColumnDef, 'colId' | 'field'>): string {
    return colId ?? field;
}
